import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {}

const FuelingCardHeader = (props: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <div className="text-muted font-weight-bold">
      <div className="row no-gutters align-items-center">
          <div className="col col-sm-6">
            {tLabels("fuelingCardHeader.cardNumber")}
          </div>
          <div className="col-auto col-sm-6 pl-3">
            <span className="d-sm-none">
              {tLabels("fuelingCardHeader.date")}
            </span>
            <div className="d-none d-sm-flex row no-gutters align-items-center">
              <div className="col-sm-6 text-right text-sm-left">
                {tLabels("fuelingCardHeader.dateFrom")}
              </div>
              <div className="col-sm-6 text-right pr-2 pr-sm-0 text-nowrap">
                {tLabels("fuelingCardHeader.dateTo")}
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default FuelingCardHeader;